import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getDestinasi } from '../../actions/DestinasiAction';
import { DELETE_DESTINASI, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import { logOutUser } from 'actions/AuthAction';
import jwt_decode from 'jwt-decode';

export default function ListDestinasi() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    getListDestinasiError,
    getListDestinasiLoading,
    getListDestinasiResult,
  } = useSelector((state) => state.DestinasiReducer);

  // auth

  const [token, setToken] = useState('');
  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [akses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');

  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token');
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setNama(decoded.nama);
      setAccessToken(response.data.accessToken);
      setUsername(decoded.username);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token');
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  useEffect(() => {
    dispatch(getDestinasi());
    refreshToken();
  }, []);

  const removeData = async (id) => {
    try {
      await axios.delete(DELETE_DESTINASI + `${id}`, {
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      swal('Sukses!', 'Destinasi berhasil dihapus', 'success');
      history.push('/admin');
      history.push('/admin/destinasi');
    } catch (error) {
      swal('Failed!', 'Forbiden', 'error');
    }
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>List Destinasi</CardTitle>
              <Link
                to={'/admin/destinasi/tambah/' + idAdmin}
                className='btn btn-primary float-right'
              >
                Tambah Destinasi
              </Link>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>Foto</th>
                    <th>Nama</th>
                    <th>Desa</th>
                    <th>Kecamatan</th>

                    <th>Koordinat</th>
                    <th>Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  {getListDestinasiResult ? (
                    Object.keys(getListDestinasiResult).map((key) => (
                      <tr key={key}>
                        <td>{getListDestinasiResult[key].id}</td>
                        <td>
                          <img
                            src={
                              getListDestinasiResult[key].gambar.split(',')[0]
                            }
                            width='100'
                            alt={getListDestinasiResult[key].kategori}
                          />
                        </td>
                        <td>{getListDestinasiResult[key].nama}</td>
                        <td>{getListDestinasiResult[key].desa}</td>
                        <td>{getListDestinasiResult[key].kecamatan}</td>

                        <td>{getListDestinasiResult[key].koordinat} </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/destinasi/edit/' +
                              getListDestinasiResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> Edit
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() =>
                              removeData(getListDestinasiResult[key].id)
                            }
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getListDestinasiLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getListDestinasiError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getListDestinasiError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
